module.exports = __webpack_public_path__ + "static/media/konosuba-lg1.c7dc618e.jpg";